export interface IClinicalVersion {
  uuid: string;
  eventName: string;
  assistanceLvl: number;
  contact: string;
  contactMethod: string;
  userUuid: string;
  timestamp: string;
  durationInSeconds?: number;
  comment?: string;
  response?: string;
}

export enum rtmEventsAllowedActions {
  wildCard = '*',
  read = 'read',
  write = 'write',
}

export interface IClinicalEvent {
  uuid: string;
  isVoid: boolean;
  serviceTime: string;
  clinicianUuid: string;
  versions: IClinicalVersion[];
  localeTimezone?: string;
  allowedActions: rtmEventsAllowedActions[];
}

export interface IUseRtmEventsService {
  data: IClinicalEvent[];
  isLoading: boolean;
  getEvent(uuid: string): IClinicalEvent | undefined;
  insertAction({
    serviceTime,
    localeTimezone,
  }: {
    serviceTime: string;
    localeTimezone: string;
  }): Promise<string>;
  allowAmmend(uuid: string): boolean;
  ammendAction({
    data,
    isMonitoring,
  }: {
    data: IClinicalVersion;
    isMonitoring?: boolean;
  }): Promise<void>;
  allowVoid(uuid: string): boolean;
  voidAction({ uuid, isMonitoring }: { uuid: string; isMonitoring?: boolean }): Promise<void>;
  isEventInEditableDateRange(uuid: string): boolean;
  isError?: boolean;
}
